module.exports = __webpack_public_path__ + "img/title.4d2d9052.svg";